import { defineMessages } from "react-intl";

export const manualTransactionMessages = defineMessages({
  dialogTitle: {
    defaultMessage: "Capture manual transaction",
    id: "kuo4fW",
    description: "dialog title",
  },
  dialogDescription: {
    defaultMessage: "Create a manual transaction for non-integrated payments",
    id: "TTVPyd",
    description: "dialog subheading",
  },
  submitButton: {
    defaultMessage: "Create manual transaction",
    id: "AMlXrQ",
    description: "submit button",
  },
  transactionAmount: {
    defaultMessage: "Transaction amount",
    id: "Ftz7VI",
    description: "input label, transaction amount",
  },
});
